import { Injectable } from '@angular/core';
import axios from 'axios';
import { AuthService } from '@services/auth/auth.service';
import { environment, BASE_URL_SERVICIOS_USUARIOS } from "@env/environment";
import { Router } from '@angular/router';
import { ToolsService } from '@services/varios/tools.service';
import { Log } from 'src/app/common/interfaces/log.interface';

@Injectable({
	providedIn: 'root'
})

export class LogsService {

	constructor(private readonly authService: AuthService, private readonly router: Router, private readonly toolsService: ToolsService) { }

	public async getLogByFechas(fechaInicio: any, fechaFin: any) {
		let BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getLogByFechas?idSistema=' + environment.idSistema + '&fechaInicio=' + fechaInicio + '&fechaFin=' + fechaFin;

		return await axios.get(BASE_URL, {
			onDownloadProgress: async progressEvent => {
				if (progressEvent.progress == 1) {
					await this.toolsService.okMensaje("Archivo generado exitosamente")
				};
			},
			headers: {
				'apiKey': environment.apiKeyCargaUsuarios,
			}, responseType: 'blob'
		})
			.then(async response => {
				if (response.data.size == 0) {
					await this.toolsService.errorMensaje("No existen registros para este rango de fechas");
				} else {
					const href = window.URL.createObjectURL(response.data);
					const anchorElement = document.createElement('a');
					anchorElement.href = href;
					anchorElement.download = 'Log.xlsx';;
					document.body.appendChild(anchorElement);
					anchorElement.click();
					document.body.removeChild(anchorElement);
					window.URL.revokeObjectURL(href);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}

	public async addLogSistema(accion: string, descripcion: string): Promise<Log> {
		let UsrInfo = this.authService.getUserInfo();
		let log: Log = {} as Log;
		log.idSistema = environment.idSistema;
		log.idUsuario = UsrInfo.usuario.idUsuario;
		log.fecha = new Date;
		log.accion = accion;
		log.descripcion = descripcion;

		const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/addLogSistema';

		return await axios.post(BASE_URL, log, {
			headers: {
				'apiKey': environment.apiKeyCargaUsuarios,
			},
		}).then(resp => {
			if (resp.data.respuesta == 'ok') {
				return resp.data;
			} else {
				let rs: Log = {} as Log;
				return rs;
			}
		}).catch(async error => {
			if (error.response.status == 401) {
				sessionStorage.clear();
				await this.toolsService.errorSesionMensaje();
				this.router.navigate(['/']);
			}
		});
	}
}
